import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { videoList, getCustomer } from './request.js';
import { mapState } from 'vuex';
import mixin from './mixin.js';
import moment from 'moment';
import playerModal from './playerModal.vue';
export default {
  components: {
    playerModal
  },
  mixins: [mixin],
  computed: {
    ...mapState({
      tagList: state => state.tagsView.tagList
    })
  },
  data() {
    return {
      form: {
        customerId: '',
        orderNo: '',
        startRecordTime: [],
        startAt: '',
        endAt: ''
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'seq',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'seq'
        }
      }, {
        slots: {
          title: '订单号'
        },
        dataIndex: 'orderId',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '视频大小'
        },
        dataIndex: 'size',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '视频ID'
        },
        dataIndex: 'loginId',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '录屏开始时间'
        },
        dataIndex: 'startAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 150,
        key: '9'
      }]
    };
  },
  created() {
    this.routerPath = this.$route.path;
    this.getCustomerData();
  },
  methods: {
    customerChange(value) {
      this.form.customerId = value;
      sessionStorage.setItem('selectCustomId', value);
      this.searchFun();
    },
    async getCustomerData() {
      const res = await getCustomer({});
      if (res.length > 0) {
        this.customerList = res;
        let customerId = sessionStorage.getItem('selectCustomId');
        this.form.customerId = customerId ? Number(customerId) : res[0].id;
        this.$nextTick(() => {
          this.searchFun();
        });
      }
    },
    searchFun() {
      let {
        current,
        pageSize
      } = this.pagination;
      let {
        customerId,
        orderNo,
        startRecordTime
      } = this.form;
      orderNo = orderNo ? orderNo.replace(/\s*/g, '') : '';
      let startAt = startRecordTime[0] ? moment(startRecordTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      let endAt = startRecordTime[1] ? moment(startRecordTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      let params = {
        page: current,
        pageSize: pageSize,
        source_channel: 3,
        customerId: customerId,
        orderNo: orderNo,
        startAt: startAt,
        endAt: endAt
      };
      videoList(params).then(res => {
        let currentIndex = (current - 1) * pageSize;
        if (res && res.items) {
          res.items.forEach((item, index) => {
            currentIndex++;
            item.seq = currentIndex;
          }) || [];
          this.data = res.items;
          this.pagination.total = res.totalNum || 0;
        }
      });
    }
  }
};